<template>
  <notLoginLayout class="login">
    <b-form>
      <b-form-group
        id="login-account"
        label="帳號"
        label-for="account"
        class="required-icon-star"
      >
        <b-form-input
          id="account"
          v-model="loginForm.account"
          :state="verifyAccount"
          :title="'輸入格式有誤'"
          @keydown.enter="verifyLoginForm"
          type="text"
          required
          placeholder="請輸入帳號( 非信箱 )"
        ></b-form-input>
      </b-form-group>
      <b-form-group
        id="login-password"
        label="密碼"
        label-for="password"
        class="required-icon-star"
      >
        <b-form-input
          id="password"
          v-model="loginForm.password"
          :state="verifyPassword"
          :title="'輸入格式有誤'"
          @keydown.enter="verifyLoginForm"
          type="password"
          required
          placeholder=""
        ></b-form-input>
      </b-form-group>
      <div class="text-center">
        <b-button @click="verifyLoginForm" type="button" variant="primary"
          >登入</b-button
        >
      </div>
    </b-form>
    <div class="forget spacer text-center">
      <b-button @click="forget('password')" class="mr-3" type="reset"
        >忘記密碼</b-button
      >
      <b-button @click="forget('account')" type="reset">忘記帳號</b-button>
    </div>
    <div class="spacer text-center">
      <p>
        還沒有帳號嗎？
        <span @click="showModal" class="application">申請帳號</span>
      </p>
    </div>

    <!-- modal -->
    <b-form class="application-form">
      <b-modal ref="account-application" title="帳號申請">
        <b-form-group
          id="input-group-1"
          label="帳號"
          label-for="account"
          class="required-icon-star"
        >
          <b-form-input
            id="account"
            v-model="applicationForm.account"
            :state="verifyAccount"
            :title="'輸入格式有誤'"
            type="text"
            required
            placeholder="請用英文、數字、底線做組合，格式範例：ab_c-12"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-2"
          label="真實姓名"
          label-for="name"
          class="required-icon-star"
        >
          <b-form-input
            id="name"
            v-model="applicationForm.name"
            :state="verifyName"
            :title="'輸入格式有誤'"
            type="text"
            required
            placeholder=""
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-3"
          label="email"
          label-for="email"
          class="required-icon-star"
        >
          <b-form-input
            id="email"
            v-model="applicationForm.email"
            :state="verifyEmail"
            :title="'輸入格式有誤'"
            type="text"
            required
            placeholder="格式範例：xxxx@gmail.com"
          ></b-form-input>
        </b-form-group>
        <b-form-group
          id="input-group-4"
          label="手機"
          label-for="phone"
          class="required-icon-star"
        >
          <b-form-input
            id="phone"
            v-model="applicationForm.phone"
            :state="verifyPhone"
            :title="'輸入格式有誤'"
            type="tel"
            maxlength="10"
            required
            placeholder="格式範例：0912345678"
          ></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-5" label="投資資歷" label-for="seniority">
          <b-form-input
            id="seniority"
            v-model="applicationForm.seniority"
            :state="verifySeniority"
            :title="'輸入格式有誤'"
            type="tel"
            maxlength="2"
            required
            placeholder="請填入數字，格式範例：3"
          ></b-form-input
          >年
        </b-form-group>
        <b-form-group
          id="input-group-6"
          label="自我介紹"
          label-for="introduction"
        >
          <b-form-textarea
            id="introduction"
            v-model="applicationForm.introduction"
            :state="verifyIntroduction"
            :title="'輸入格式有誤'"
            placeholder="請在 255 字內簡單自我介紹"
            rows="5"
          ></b-form-textarea>
        </b-form-group>
        <template v-slot:modal-footer>
          <div class="text-center">
            <b-button
              @click="verifyApplicationForm"
              class="mr-3"
              type="button"
              variant="primary"
              >送出</b-button
            >
          </div>
        </template>
      </b-modal>
    </b-form>
  </notLoginLayout>
</template>

<script>
import notLoginLayout from "@/layout/NotLoginLayout.vue";
import mixinsVerify from "@/utility/mixinsVerify.js";

export default {
  components: {
    notLoginLayout
  },
  data() {
    return {
      loginForm: {
        account: "",
        password: ""
      },
      applicationForm: {
        account: "",
        name: "",
        email: "",
        phone: "",
        seniority: "",
        introduction: ""
      }
    };
  },
  mixins: [mixinsVerify],
  methods: {
    forget(currentForgetFlow) {
      switch (currentForgetFlow) {
        case "password":
          this.$store.commit("currentForgetFlow", "password");
          break;
        default:
        case "account":
          this.$store.commit("currentForgetFlow", "account");
          break;
      }
      this.$router.push({ name: "accountCheck" });
    },
    verifyLoginForm() {
      this.verifyAccount =
        this.hasValue(this.loginForm.account) === null
          ? this.accountRegexp(this.loginForm.account)
          : false;
      this.verifyPassword =
        this.hasValue(this.loginForm.password) === null
          ? this.passwordRegexp(this.loginForm.password)
          : false;
      if (this.verifyAccount === false || this.verifyPassword === false) return;
      else this.submit();
    },
    submit() {
      this.$store
        .dispatch("FETCH_TOKEN", this.loginForm)
        .then(() => {
          this.$router.push({ path: "/stock/2330/report-year" });
        })
        .catch(e => {
          if (e.status === 401 || e.status === 422) {
            this.verifyAccount = false;
            this.verifyPassword = false;
          }
        });
    },
    showModal() {
      this.$refs["account-application"].show();
      this.verifyAccount = null;
    },
    verifyApplicationForm() {
      this.verifyAccount =
        this.hasValue(this.applicationForm.account) === null
          ? this.accountRegexp(this.applicationForm.account)
          : false;
      this.verifyName = this.hasValue(this.applicationForm.name);
      this.verifyEmail =
        this.hasValue(this.applicationForm.email) === null
          ? this.emailRegexp(this.applicationForm.email)
          : false;
      this.verifyPhone =
        this.hasValue(this.applicationForm.phone) === null
          ? this.phoneRegexp(this.applicationForm.phone)
          : false;
      this.verifySeniority = Number.isNaN(
        Number(this.applicationForm.seniority)
      )
        ? false
        : null;
      this.verifyIntroduction = this.introductionRegexp(
        this.applicationForm.introduction
      );
      if (
        this.verifyAccount === false ||
        this.verifyName === false ||
        this.verifyEmail === false ||
        this.verifyPhone === false ||
        this.verifySeniority === false ||
        this.verifyIntroduction === false
      )
        return;
      else this.applicationSubmit();
    },
    applicationSubmit() {
      this.applicationForm.seniority = Number(this.applicationForm.seniority);
      this.$store
        .dispatch("register", this.applicationForm)
        .then(() => {
          alert("申請成功，待管理員審核通過，您將收到帳號開通信。");
          this.$refs["account-application"].hide();
        })
        .catch(e => {
          if (e.data && e.data.errors.account) {
            alert(e.data.errors.account);
            this.verifyAccount = false;
          } else if (e.data && e.data.errors.email) {
            alert(e.data.errors.email);
            this.verifyEmail = false;
          }
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  .spacer {
    margin: 20px 0;
  }
  .application {
    color: red;
    padding: 5px 10px;
    cursor: pointer;
  }
}
</style>
